import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { AdminNewGuestPageRoutingModule } from './admin-new-guest-routing.module';

import { AdminNewGuestPageComponent } from './admin-new-guest.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdminNewGuestPageRoutingModule
  ],
  declarations: [AdminNewGuestPageComponent]
})
export class AdminNewGuestPageModule {}
